import { all, fork, select, takeLatest, put } from 'redux-saga/effects';
import { sagas } from '@wix/da-shared-react/pkg/redux/shared';
import { sisuFunnelSaga } from '@wix/da-shared-react/pkg/redux/sisuFunnel/saga';
import { appMounted } from '@wix/da-shared-react/pkg/redux/app/actions';
import { addNotificationToQueue } from '@wix/da-shared-react/pkg/Notifications/redux/actionCreators';
import { NotificationType } from '@wix/da-shared-react/pkg/Notifications';
import { getDeviationNotificationQueue } from '@wix/da-shared-react/pkg/DeviationPage/redux/helpers';
import { getCurrentItem } from '@wix/da-shared-react/pkg/Duperbrowse/redux/selectors';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags';
import {
  hasFirstTimeFlag,
  dropFirstTimeFlag,
  FirstTimeFlag,
} from '@wix/da-shared-react/pkg/redux/firstTimeFlags';

function* appMountedSaga() {
  const postSubmitGroupCTA = yield select(flagEnabled, 'post_submit_group_cta');
  const postSubmitGroupFTUE = yield select(
    hasFirstTimeFlag,
    FirstTimeFlag.IsDevpageAddToGroupNotShown
  );
  const deviation: ReturnType<typeof getCurrentItem> = yield select(
    getCurrentItem
  );

  if (
    postSubmitGroupCTA &&
    postSubmitGroupFTUE &&
    deviation &&
    typeof window !== 'undefined'
  ) {
    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get('ga_submit_new')) {
      yield put(addNotificationToQueue(
        getDeviationNotificationQueue(deviation),
        NotificationType.GroupPrompt,
        {}
      ));
      yield put(dropFirstTimeFlag({
        flag: FirstTimeFlag.IsDevpageAddToGroupNotShown,
      }));
    }
  }
}

export default function* daDeviationRootSaga() {
  yield all([
    takeLatest(appMounted, appMountedSaga),
    ...sagas.map(fork),
    fork(sisuFunnelSaga)
  ]);
}
